import { useDownloadCsv } from '@fukuri-admins/hooks/common';

type Options = {
  onSuccess?: (blob: Blob) => void;
  onError?: (error: Error) => void;
};

type Args = {
  /** パートナーコード */
  threeLetterCode: string;
};

/**
 * 利用企業一覧 CSV ダウンロード hook
 *
 * `GET /api/v1/:threeLetterCode/partner_admins/clients.csv` で
 * CSV を取得し、ボタンクリック時（`trigger()` 呼び出し時）に 1 回だけダウンロードする。
 *
 * 旧実装 `getClientsCSV` と同様、クエリパラメータなしで全件取得する。
 * 検索条件の CSV 反映は LEA-3373 で対応する。
 *
 * @param args - パートナーコード
 * @param options - 成功時 / 失敗時コールバック
 */
export const useGetPartnerAdminsClientsCsv = ({ threeLetterCode }: Args, options?: Options) => {
  const url = `/api/v1/${threeLetterCode}/partner_admins/clients.csv`;

  return useDownloadCsv(url, options);
};
